module.exports = __webpack_public_path__ + "static/img/Bachelor_010796.22d7f01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010796.jpg
// module id = 251
// module chunks = 0